import { colors } from 'helpers/chart';
import { toDeci, formatMetric } from 'helpers/formatter';

export const riskMeasuresRatios = ['Sharpe Ratio', 'Sortino Ratio', 'Omega Ratio'];
export const riskMeasuresPerc0 = ['Standard Deviation', 'CVaR 95%', 'Maximum Drawdown'];
export const riskMeasuresPerc = ['Cumulative Return', 'CAGR', 'Downside Deviation', ...riskMeasuresPerc0];
export const riskMeasuresDeci = ['Beta', 'Skew', 'Kurtosis', ...riskMeasuresRatios, 'Correlation'];
export const riskMeasuresDeci2 = [...riskMeasuresDeci, 'MAR Ratio (RoMaD)', 'Treynor Ratio', 'VAMI'];
export const riskMeasuresCurrency = ['VAMI'];
export const riskMeasuresAll = [...riskMeasuresPerc, ...riskMeasuresDeci];

export const riskRatioGroups = [
  {
    label: 'CAGR and Std Dev',
    value: { keys: ['CAGR', 'Standard Deviation'], type: 'percentage' },
  },
  {
    label: 'Beta and Correlation',
    value: { keys: ['Beta', 'Correlation'], type: 'decimal' },
  },
  {
    label: 'CVaR and Max DD',
    value: { keys: ['CVaR 95%', 'Maximum Drawdown'], type: 'percentage' },
  },
  {
    label: 'Std Dev and Downside Dev',
    value: { keys: ['Standard Deviation', 'Downside Deviation'], type: 'percentage' },
  },
  {
    label: 'Skew and Kurtosis',
    value: { keys: ['Skew', 'Kurtosis'], type: 'decimal' },
  },
  {
    label: 'Sharpe and Sortino',
    value: { keys: ['Sharpe Ratio', 'Sortino Ratio'], type: 'decimal' },
  },
  {
    label: 'Beta and Treynor',
    value: { keys: ['Beta', 'Treynor Ratio'], type: 'decimal' },
  },
  {
    label: 'MAR and Omega',
    value: { keys: ['MAR Ratio (RoMaD)', 'Omega Ratio'], type: 'decimal' },
  },
  {
    label: 'Ratios (Sharpe, Sortino, Omega)',
    value: { keys: ['Sharpe Ratio', 'Sortino Ratio', 'Omega Ratio'], type: 'decimal' },
  },
];

export const drawdownMetrics = [
  {
    label: 'CAGR and Max DD',
    value: { keys: ['CAGR', 'Standard Deviation', 'Maximum Drawdown'], type: 'percentage' },
  },
  {
    label: 'DD and Recovery Duration',
    value: { keys: ['Drawdown Duration', 'Recovery Duration to HWM'], type: 'text' },
  },
  {
    label: 'Ratios',
    value: { keys: ['Calmar Ratio', 'MAR Ratio (RoMaD)', 'Sterling Ratio'], type: 'decimal' },
  },
];

const riskMetricBase = 'CAGR';
export const riskMetricBubbleChartMetricOptions = [
  'Standard Deviation',
  'Beta',
  'CVaR 95%',
  'Maximum Drawdown',
  'Downside Deviation',
  'Skew',
  'Kurtosis',
].map((value) => ({
  label: `${riskMetricBase} and ${value}`,
  value,
}));

export function getRiskMetricBubbleChartMeta(target, selectedBubbleChartMetricOption) {
  if (!target || !selectedBubbleChartMetricOption) return {};

  const rowTitles = target.index;
  const colTitles = target.columns;

  const indCG = colTitles.indexOf(riskMetricBase);
  const indUS = colTitles.indexOf(selectedBubbleChartMetricOption.value);

  const xLabel = `${selectedBubbleChartMetricOption.value}`;
  const xTickCallback = (val) => formatMetric(selectedBubbleChartMetricOption.value, val, { absolute: true });
  const tooltipLabel = (item) =>
    `${item.dataset.label}: ${formatMetric(riskMetricBase, item.raw.y)}, ${formatMetric(
      selectedBubbleChartMetricOption.value,
      item.raw.x,
    )}`;

  return {
    data: {
      datasets: rowTitles.map((title, ind) => {
        return {
          label: title,
          data: [
            {
              x: target.data[ind][indUS],
              y: target.data[ind][indCG],
            },
          ],
          pointRadius: 13,
          pointHoverRadius: 5,
          backgroundColor: colors[ind % colors.length],
        };
      }),
    },
    options: {
      plugins: {
        legend: { display: rowTitles.length < 5 },
        tooltip: {
          enabled: true,
          callbacks: {
            label: tooltipLabel,
          },
        },
      },
      scales: {
        x: {
          title: {
            display: true,
            text: xLabel,
          },
          ticks: { callback: xTickCallback, color: ({ tick }) => (tick.value < 0 ? 'red' : 'black') },
          beginAtZero: true,
        },
        y: {
          title: {
            display: true,
            text: 'Annualized Return',
          },
          ticks: {
            callback: (val) => formatMetric(riskMetricBase, val, { absolute: true }),
            color: ({ tick }) => (tick.value < 0 ? 'red' : 'black'),
          },
          beginAtZero: true,
        },
      },
    },
  };
}
